import React, { useState } from 'react';
import axios from 'axios';
import '../styles.css'; // Ensure styles are properly linked

const API_URL = process.env.REACT_APP_API_URL || 'http://52.25.19.40:3030/api/contact'; 

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    
    try {
      await axios.post(API_URL, formData);
      setStatus('success');
      setFormData({ name: '', email: '', message: '' });
    } catch (error) {
      console.error('Error sending message:', error);
      setStatus('error');
    }
  };

  return (
    <div className="container mt-5">
      <h1 className="text-warning text-center">📞 Contact Sirius Music</h1>
      <p className="text-center lead">We'd love to hear from you! Fill out the form below and we'll be in touch.</p>

      <div className="row justify-content-center">
        <div className="col-md-6">
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="mb-3">
              <label className="form-label">Name</label>
              <input 
                type="text" 
                className="form-control" 
                name="name" 
                value={formData.name} 
                onChange={handleChange} 
                required 
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Email</label>
              <input 
                type="email" 
                className="form-control" 
                name="email" 
                value={formData.email} 
                onChange={handleChange} 
                required 
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Message</label>
              <textarea 
                className="form-control" 
                name="message" 
                rows="4" 
                value={formData.message} 
                onChange={handleChange} 
                required 
              ></textarea>
            </div>
            <button type="submit" className="btn btn-warning w-100">Send Message</button>
          </form>

          {status === 'sending' && <p className="text-info text-center mt-3">Sending message...</p>}
          {status === 'success' && <p className="text-success text-center mt-3">Message sent successfully!</p>}
          {status === 'error' && <p className="text-danger text-center mt-3">Error sending message. Please try again.</p>}
        </div>
      </div>

      <div className="text-center mt-5">
        <h2 className="text-warning">📍 Contact Information</h2>
        <p>📧 Email: <a href="mailto:info@siriusmusic.com">info@siriusmusic.com</a></p>
        <p>📍 Location: Los Angeles, California | Nairobi, Kenya</p>
      </div>
    </div>
  );
};

export default Contact;